import { Channel } from '@/app/store/api/restApi';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { LaunchAttribution } from '@/shared/lib/attribution';

export interface AttributionState {
  current: LaunchAttribution;
}

const initialState: AttributionState = {
  current: { channel: Channel.Organic },
};

export const attributionSlice = createSlice({
  name: 'attribution',
  initialState,
  reducers: {
    setAttribution(state, { payload }: PayloadAction<LaunchAttribution>) {
      state.current = payload;
    },
  },
});

export const { setAttribution } = attributionSlice.actions;

export const attributionReducer = attributionSlice.reducer;

export const selectAttribution = (state: { attribution: AttributionState }): LaunchAttribution =>
  state.attribution.current;
